import ModalContent from './ModalContent'
import ModalHeader from './ModalHeader'
import ModalRoot from './ModalRoot'
import ModalTrigger from './ModalTrigger'
import MotionModalContent from './MotionModalContent'
import MotionModalRoot from './MotionModalRoot'

export const Modal = {
  Root: ModalRoot,
  Header: ModalHeader,
  Content: ModalContent,
  Trigger: ModalTrigger,
  MotionRoot: MotionModalRoot,
  MotionContent: MotionModalContent,
}
